import { Observable } from 'rxjs';

import { Location } from '../models';
import { AssetDAO } from './asset.dao';
import { BaseDAO } from './base.dao';

export class LocationDAO extends BaseDAO<Location> {
  private _assets: Observable<AssetDAO[]>;

  public get mfgAssets(): Observable<AssetDAO[]> {
    if (this._assets == null) {
      const path = `${this.path}/mfgAssets`;
      this._assets = this.initCollection(AssetDAO, path);
    }
    return this._assets;
  }
}
